import React, { useCallback } from 'react'
import { Button, Card, Col, Form, Input, Row, Typography } from 'antd'
import { useCheckTokenMutation } from 'store/auth/api'
import Layout from 'components/Layout'

const Login = () => {
  const [ form ] = Form.useForm()
  const [ checkToken, {isLoading, data} ] = useCheckTokenMutation()

  const onSubmit = useCallback(
    async ({token}) => {
      await checkToken({token})
    },
    [ checkToken ]
  )

  return (
    <Layout>
      <Row justify="center" align="middle" style={ {height: '70vh'} }>
        <Col xs={ 24 } sm={ 24 } md={ 8 } lg={ 8 } xl={ 6 } xxl={ 4 }>
          <Card>
            <Form form={ form } layout="vertical" onFinish={ onSubmit }>
              <Row justify="center" align="middle">
                <Col>
                  <Typography.Title level={ 2 }>Login</Typography.Title>
                </Col>
                <Col span={ 24 }>
                  <Form.Item name="token" rules={ [ {required: true} ] } validateStatus={data?.valid === false ? 'error' : ''}>
                    <Input type="password" placeholder="Token"/>
                  </Form.Item>
                </Col>
                <Col>
                  <Button loading={ isLoading } type="primary" htmlType="submit">
                    Send
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </Layout>
  )
}

export default Login
